<template>
  <div class="form-detail">
    <el-table :data="tableDatalist" border style="width: 100%">
      <!-- <el-table-column label="备案流水号" width="220" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.serialCode }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="预案类型">
        <template slot-scope="scope">
          <span v-if="scope.row.processKey=='HeavyPollWeather'">重污染天气应急预案</span>
          <span v-if="scope.row.processKey=='SuddenEnvEvent'">突发环境事件应急预案</span>
        </template>
      </el-table-column>
      <el-table-column label="申报单位名称">
        <template slot-scope="scope">
          <span>{{ scope.row.subjectName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建日期" width="120">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.createDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请日期" width="120">
        <template slot-scope="scope">
          <span>{{ formatTime(scope.row.startDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请人" >
        <template slot-scope="scope">
          <span>{{ scope.row.creatorName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="当前备案进度">
        <template slot-scope="scope">
            <span v-if="scope.row.isAdopt">{{scope.row.step}}</span>
            <span v-if="!scope.row.isAdopt"><span style="margin-right:20px;">不通过</span><button class="btnTheme" type="text" size="small" @click="handle(scope.row)">查看备案详情</button></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center" class="aimee-btn">
        <template slot-scope="scope">
          <button class="btnTheme" type="text" size="small" @click="handle(scope.row)">备案进度</button>
          <button class="btnTheme" type="text" size="small" @click="handleInfo(scope.row)">备案信息</button>
          <button v-if="!scope.row.withdraw" class="btnTheme" type="text" size="small" @click="handleGet(scope.row)" :disabled="formatisTrue(scope.row.state)">继续完善</button>
          <button v-if="scope.row.isAdopt" class="btnTheme colorred" type="text" size="small"  @click="removeID(scope.row)"  :disabled="formatisTrue(scope.row.state)">撤销备案</button>
          <button v-if="!scope.row.isAdopt" class="btnTheme colorred" type="text" size="small"  @click="removeID(scope.row)"  :disabled="formatisTrue(scope.row.state)">废弃备案</button>
          <button v-if="scope.row.withdraw" class="btnTheme colorred" type="text" size="small" @click="withdrawClick(scope.row)" >撤回备案</button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="撤回备案" :visible.sync="withdrawState" width="200px" :modal-append-to-body='false' class="withdrawState">
      <el-form :model="withdraw" :rules="rules" ref="form-withdraw">
        <p>确定撤回此次备案？此操作会撤回已提交的当前备案</p>
        <p>请输入操作依据：</p>
        <el-form-item prop="opinion">
          <el-input type="textarea" autofocus v-model="withdraw.opinion" :maxlength="255" placeholder="请输入操作依据" :rows="5"></el-input>
        </el-form-item>
        <p>如需编辑信息，请点击“继续完善”按钮</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="withdrawState = false">取 消</el-button>
        <el-button type="primary" @click="confirm_withdraw">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import weather from '../../data/emer/weather.js'
import { mapMutations } from 'vuex'
export default {
  data() {
    var verify_empty = (rule, value, callback) => {
        if (!value || (typeof value === "string" && value.trim() === "")) {
            callback(new Error("当前不能为空"));
        } else {
            callback();
        }
    };
    return {
      withdraw:{
        opinion: '',
        instanceId:'',
        fromManager: false
      },
      withdrawState: false,
      // 数据
      tableDatalist: [],
      // 类型
      subjectId: '',
      istrue: false,
      getStepData:'',
      // 总数
      num: 0,
      rules: {
        opinion: [
          { required: true, message: '请输入操作依据', trigger: 'blur' },
          { validator: verify_empty, trigger: "blur" },
          {max: 255,message: "依据长度不要超过255",trigger: "blur"}
        ]
      }
    }
  },
  created() {
    if (sessionStorage.itemName) {
      this.getDataNo()
    } else {
      this.message.warning('请求超时,请重试！！！')
    }
  },
  methods: {
    getDataNo() {
      this.num = 0;
      this.tableDatalist = [];
      //正在备案
      (async() => {
        this.subjectId = JSON.parse(sessionStorage.itemName).id
        let getState = await weather.process_running({
          subjectId: this.subjectId,
          processKey: 'HeavyPollWeather'
        })
        if (getState.status) {
          this.num += getState.data.totalElements;
          this.$emit('setNum')
          for (let i = 0; i < getState.data.content.length; i++) {
              getState.data.content[i].isAdopt = true
          }
          this.tableDatalist = this.tableDatalist.concat(getState.data.content)
          this.tableDatalist.sort(this.compare('createDate'))
        } else {
          this.$message.error(getState.msg)
        }
      })();
      //被打回
      (async () => {
          this.subjectId = JSON.parse(sessionStorage.itemName).id;
          let getState = await weather.process_refused({
          subjectId: this.subjectId,
          processKey: "HeavyPollWeather"
          });
          if (getState.status) {
              this.num += getState.data.totalElements;
              this.$emit('setNum')
              for (let i = 0; i < getState.data.content.length; i++) {
                      getState.data.content[i].isAdopt = false
                  }
              this.tableDatalist = this.tableDatalist.concat(getState.data.content)
              this.tableDatalist.sort(this.compare('createDate'))
          } else {
          this.$message.error(getState.msg);
          }
      })();
    },
    compare(prop){
        return function (obj1, obj2) {
            let val1 = moment(obj1[prop], 'YYYY-MM-DD HH:mm:ss').valueOf();
            let val2 = moment(obj2[prop], 'YYYY-MM-DD HH:mm:ss').valueOf();
            if (val1 < val2) {
                return -1;
            } else if (val1 > val2) {
                return 1;
            } else {
                return 0;
            }            
        } 
    },
    formatisTrue(status) {
        return status === 1 || status === 20 ? false : true
    },
    // 获取步骤
    handleGet(val) {
      sessionStorage.planIdval = val.planId
      this.get_stepData({
        planId: val.planId
      })
      this.gov_detail({
        planId: val.planId,
        subjectType: val.subjectType,
        instanceId: val.instanceId
      })
      this.subjectType = val.subjectType
    },
    // 获取存储步骤
    get_stepData(params) {
      // (async() => {
      //   let getState = await weather.get_step(params)
      //   if (getState.status) {
      //     this.getStepData = getState.data
      //   } else {
      //     this.$message.error(getState.msg)
      //   }
      // })()
      this.getStepData = 1;
    },
    withdrawPlan(params) {
        return new Promise((resolve, reject) => {
            (async () => {
                let getState = await weather.plan_withdraw(params);
                if (getState.status) {
                    resolve(1);
                } else {
                    reject(getState.msg);
                }
            })();
        })
    },
    withdrawClick(val){
      this.withdraw.instanceId = val.instanceId;
      this.withdrawState = true;
    },
    confirm_withdraw(){
      let _this = this;
      _this.$refs["form-withdraw"].validate(valid => {
          if (valid) {
            _this.withdrawPlan(_this.withdraw).then(function (result) {
              _this.getDataNo();
              _this.$message.success("撤回备案成功");
              _this.withdrawState = false;
              _this.resetFields()
            }).catch(function(err) {
              _this.$message.error(err)
            })
          } else {
              return false;
          }
      });
    },
    resetFields() {
      this.$refs["form-withdraw"].resetFields();
    },
    remove_planID(params) {
        return new Promise((resolve, reject) => {
          (async () => {
              let getState = await weather.abandon_plan(params);
              if (getState.status) {
                  resolve(1);
              } else {
                  reject(getState.msg);
              }
          })();
        })
    },
    // 删除草稿，会删除关联信息，不留记录
    // 废弃备案，会结束流程，留记录
    removeID(val) {
        let _this = this;
        let tip = val.isAdopt?'确定撤销此次备案？此操作会删除所有备案信息，无法继续完善，请谨慎操作。':'确定废弃此次备案？此操作会终结当前备案，无法继续完善，请谨慎操作。'
        this.$confirm(tip+"如需编辑信息，请点击“继续完善”按钮", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                if (val.isAdopt) {
                    _this.remove_planID({
                        planId: val.planId
                    }).then(function (result) {
                        _this.getDataNo();
                        _this.$message.success("撤销备案成功");
                    }).catch(function(err) {
                      _this.$message.error(err)
                    })
                }else{
                    _this.remove_planID({
                        planId: val.planId,
                        instanceId: val.instanceId
                    }).then(function (result) {
                        _this.getDataNo();
                        _this.$message.success("废弃备案成功");
                    }).catch(function(err) {
                        _this.$message.error(err)
                    })
                }
            })
            .catch((err) => {
                _this.$message({
                    type: "info",
                    message: "已取消操作"
                });
            });
    },
    // 备案进度
    handle(val) {
      sessionStorage.planIdLists = val.planId
      this.$router.push({
        name: "FillingProgress",
        path: "/Filedwed/filing",
        query: {
          planId: val.planId,
          instanceId: val.instanceId,
          processKey: val.processKey
        }
      });
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return ''
      return moment(time).format('YYYY/MM/DD')
    },
    // 备案信息
    handleInfo(val) {
      sessionStorage.planIdLists = val.planId
      this.$router.push('FillingInfo')
    },
    gov_detail(params) {
      (async() => {
        let getState = await weather.subject_detail(params)
        if (getState.status) {
          this.orgdetail = getState.data
          sessionStorage.datalistobj = JSON.stringify(this.orgdetail)
          sessionStorage.subjectId = this.orgdetail.id;
          sessionStorage.step = this.getStepData
          if (this.subjectType === 1) {
            this.$router.push({
              path:'/govstep',
              query: {
                instanceId: params.instanceId,
              }
            });
          } else if (this.subjectType === 0) {
            this.$router.push({
              path:'/step',
              query: {
                instanceId: params.instanceId,
              }
            });
          } else if (this.subjectType != 0 || this.subjectType != 1) {
            this.$message.warning('申报类型不匹配,仅支持企业、政府')
          }
        } else {
          this.$message.error(getState.msg)
        }
      })()
    },
  }

}

</script>
<style lang="stylus" scoped>
.btnTheme {
  display: inline-block;
  margin-left: 0;
  font-size: 12px;
  border: none;
  color: #20a0ff;
  background: 0 0;
  padding-left: 0;
  padding-right: 0;
}

.aimee-btn button {
  border: none;
  background: none;
  outline: none;
  color: #20a0ff;
  cursor: pointer;
}

button:disabled {
  color: #ddd
}

.colorred {
  color:red;
}

.btnTheme:hover{
  text-decoration: underline;
}
.withdrawState p{
  padding: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// recording.vue?7c598d7a